import React from 'react';

const Watch = () => {
  return (
    <svg
      width='70'
      height='70'
      viewBox='0 0 60 84'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M27.0625 47.875H38.8125V42H30V27.3125H24.125V44.9375L27.0625 47.875Z'
        fill='#B49714'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.3125 16.5554C10.8454 19.1331 7.13601 22.8419 4.55765 27.3087C1.97929 31.7754 0.62291 36.8425 0.625002 42C0.62291 47.1575 1.97929 52.2246 4.55765 56.6913C7.13601 61.1581 10.8454 64.8669 15.3125 67.4446V80.1875L18.25 83.125H41.75L44.6875 80.1875V67.4446C49.1546 64.8669 52.864 61.1581 55.4423 56.6913C58.0207 52.2246 59.3771 47.1575 59.375 42C59.3771 36.8425 58.0207 31.7754 55.4423 27.3087C52.864 22.8419 49.1546 19.1331 44.6875 16.5554V3.8125L41.75 0.875H18.25L15.3125 3.8125V16.5554ZM53.5 42C53.5 48.2326 51.0241 54.2099 46.617 58.617C42.2099 63.0241 36.2326 65.5 30 65.5C23.7674 65.5 17.7901 63.0241 13.383 58.617C8.97589 54.2099 6.5 48.2326 6.5 42C6.5 35.7674 8.97589 29.7901 13.383 25.383C17.7901 20.9759 23.7674 18.5 30 18.5C36.2326 18.5 42.2099 20.9759 46.617 25.383C51.0241 29.7901 53.5 35.7674 53.5 42Z'
        fill='#B49714'
      />
    </svg>
  );
};

export default Watch;
